import { render } from "./RechargePage.vue?vue&type=template&id=519c246d&scoped=true"
import script from "./RechargePage.vue?vue&type=script&lang=js"
export * from "./RechargePage.vue?vue&type=script&lang=js"

import "./RechargePage.vue?vue&type=style&index=0&id=519c246d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519c246d"]])

export default __exports__